export default __webpack_public_path__ + "static/media/M.bfa61d60.webp";